import React, { LegacyRef, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../../api/api";
import { ReactComponent as PhotoIcon } from "../../../../assets/icons/modal/emptyPhoto.svg";
import { ICategoryCreateDto } from "../../../../types/category.type";
import SmallWhiteButton from "../../../buttons/WhiteButton/SmallWhiteButton";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddCategoryForm: React.FC<Props> = (props) => {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<any>(null);
  const [name, setName] = useState<string>("");
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [description, setDescription] = useState<string>("");

  const fileInputRef: LegacyRef<HTMLInputElement> | undefined =
    React.createRef();

  useEffect(() => {
    if (name && selectedImage) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [name, selectedImage]);

  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    setSelectedImage(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const removePhoto = () => {
    setSelectedImage(null);
    setPreviewUrl(null);
  };

  const onClickApply = async () => {
    setIsDisabled(true);
    try {
      let avatar;
      if (selectedImage) {
        const formData = new FormData();
        formData.append("file", selectedImage);

        const response = await authApiService.uploadImage(formData);
        console.log(response);
        avatar = response.publicUrl;
      }

      if (name && avatar) {
        const body: ICategoryCreateDto = {
          name,
          imageUrl: avatar,
          description,
        };

        const response = await authApiService.createCategory(body);
        if (response) {
          props.onApply();
          props.onClose();
        }
      }
    } catch (err: any) {
      console.error(err.resoponse.data);
      toast.error("Щось пішло не так. Можливо розмір фото завеликий.");
    }
    setIsDisabled(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.photoContainer}>
        {previewUrl ? (
          <img src={previewUrl} alt="employee" className={styles.image} />
        ) : (
          <PhotoIcon />
        )}
        <input
          id="file-upload"
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          ref={fileInputRef}
          className={styles.input}
        />
        <SmallWhiteButton
          onClick={previewUrl ? removePhoto : handleButtonClick}
          title={previewUrl ? "Прибрати фото" : "Додати фото"}
        />
      </div>
      <div className={styles.form}>
        <EditInput
          value={name}
          setValue={setName}
          isRequired
          title="Назва категорії"
        />
        <EditInput
          value={description}
          setValue={setDescription}
          isRequired
          title="Опис категорії"
          isBig
        />
      </div>
      <ModalBottomButtons
        onPressApply={onClickApply}
        onPressBack={props.onClose}
        applyTitle="Додати"
        backTitle="Назад"
        isApplyDisabled={isDisabled}
      />
    </div>
  );
};

export default AddCategoryForm;
